import { humanizeDate } from '../../helpers/humanizeDate';
import { ConfigurationType, ConfigurationToName } from '../dependencies/types';
import { isItemActive, mapMissingInternalIdToMetadataId } from '../helpers';
import { ContentSearchResponse, SearchListItem, SearchResponse } from './types';

export const configurationTypesOptions = [
  {
    value: ConfigurationType.apexClasses,
    label: ConfigurationToName[ConfigurationType.apexClasses],
  },
  {
    value: ConfigurationType.apexTriggers,
    label: ConfigurationToName[ConfigurationType.apexTriggers],
  },
  {
    value: ConfigurationType.approvalProcesses,
    label: ConfigurationToName[ConfigurationType.approvalProcesses],
  },
  { value: ConfigurationType.fields, label: ConfigurationToName[ConfigurationType.fields] },
  { value: ConfigurationType.flows, label: ConfigurationToName[ConfigurationType.flows] },
  {
    value: ConfigurationType.objects,
    label: ConfigurationToName[ConfigurationType.objects],
  },
  { value: ConfigurationType.layouts, label: ConfigurationToName[ConfigurationType.layouts] },
  {
    value: ConfigurationType.recordTypes,
    label: ConfigurationToName[ConfigurationType.recordTypes],
  },
  {
    value: ConfigurationType.processBuilderFlows,
    label: ConfigurationToName[ConfigurationType.processBuilderFlows],
  },
  {
    value: ConfigurationType.validationRules,
    label: ConfigurationToName[ConfigurationType.validationRules],
  },
  {
    value: ConfigurationType.workflowRules,
    label: ConfigurationToName[ConfigurationType.workflowRules],
  },
];

export const ID_NAME_SEPARATOR = '$%&';
export const generateFieldId = ({
  name,
  id,
  objectName,
}: {
  name: string;
  id?: string;
  objectName: string;
}) => (id ? id : `${ID_NAME_SEPARATOR}${name}${ID_NAME_SEPARATOR}${objectName}`);

//regexp adding space between lowerCase and capital letters
export const formatCamelCase = (text: string) => text.replace(/([a-z])([A-Z])/g, '$1 $2');

export const getSearchListItems = (
  response?: ContentSearchResponse | SearchResponse,
): SearchListItem[] => {
  if (!response) {
    return [];
  }

  return Object.keys(response).reduce((acc: any, key) => {
    const itemsOfKey = response[key as keyof SearchResponse];

    const items = itemsOfKey.map((item: any) => ({
      ...mapMissingInternalIdToMetadataId(item),
      name: item.name,
      label: item.label,
      type: item.type,
      parentType: key,
      lastModifiedAtAndBy: item.annotations?.changedAt
        ? `Last modified ${humanizeDate({ dateOrTimestamp: item.annotations?.changedAt })}`
        : '',
      createdAtAndBy: item.annotations?.createdAt
        ? `Created by ${item.annotations?.createdBy} on ${humanizeDate({ dateOrTimestamp: item.annotations?.createdAt })}`
        : '',
      objectName: item.objectName ?? '',
      objectLabel: item.objectLabel,
      match: item.match ? item.match.replace('\\\\"', '"') + '...' : undefined,
      filename: item.filename,
      isActive: isItemActive(item),
      metadataId: item.metadataId,
    }));

    return [...acc, ...(items ?? [])];
  }, []);
};
